(function () {
  function slideOffsetInTrack(slide, track) {
    return slide.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
  }

  function maxScrollLeft(track) {
    return Math.max(0, track.scrollWidth - track.clientWidth);
  }

  function isPeekLayout(track, items) {
    if (!items.length) return false;
    var width = items[0].getBoundingClientRect().width;
    return width > 0 && width < track.clientWidth * 0.92;
  }

  /**
   * Peek layouts (≈2 tiles visible) need evenly spaced scroll targets so every
   * segment maps to a unique position — especially when reversing direction.
   */
  function targetScrollForItem(track, items, index) {
    var maxScroll = maxScrollLeft(track);
    if (index <= 0 || maxScroll <= 0) return 0;
    if (index >= items.length - 1) return maxScroll;

    if (isPeekLayout(track, items) && items.length > 2) {
      return (index / (items.length - 1)) * maxScroll;
    }

    return Math.min(slideOffsetInTrack(items[index], track), maxScroll);
  }

  function nearestItemIndex(track, items) {
    if (items.length <= 1) return 0;
    var maxScroll = maxScrollLeft(track);
    if (maxScroll <= 0) return 0;

    if (isPeekLayout(track, items) && items.length > 2) {
      return Math.round((track.scrollLeft / maxScroll) * (items.length - 1));
    }

    var scrollLeft = track.scrollLeft;
    var best = 0;
    var bestDist = Infinity;
    for (var i = 0; i < items.length; i++) {
      var dist = Math.abs(targetScrollForItem(track, items, i) - scrollLeft);
      if (dist < bestDist) {
        bestDist = dist;
        best = i;
      }
    }
    return best;
  }

  function nearestPage(track, items, tilesPerPage, pageCount) {
    var scrollLeft = track.scrollLeft;
    var best = 0;
    var bestDist = Infinity;
    for (var p = 0; p < pageCount; p++) {
      var item = items[p * tilesPerPage];
      if (!item) continue;
      var dist = Math.abs(slideOffsetInTrack(item, track) - scrollLeft);
      if (dist < bestDist) {
        bestDist = dist;
        best = p;
      }
    }
    var maxScroll = maxScrollLeft(track);
    if (maxScroll > 0 && scrollLeft >= maxScroll - 4) {
      best = pageCount - 1;
    }
    return best;
  }

  function measureVisibleCount(track, items) {
    if (!items.length) return 1;
    var slideW = items[0].getBoundingClientRect().width;
    if (slideW <= 0) return 1;
    var style = window.getComputedStyle(track);
    var gap = parseFloat(style.columnGap || style.gap) || 0;
    if (isNaN(gap)) gap = 0;
    var unit = slideW + gap;
    // Floor = how many full cards fit (3-up desktop → 3). Avoid round(), which
    // can over-count to "all cards" and hide pagination.
    var count = Math.floor((track.clientWidth + gap) / unit + 0.001);
    return Math.max(1, Math.min(items.length, count || 1));
  }

  function bindSegmentCarousel(container, trackSelector, itemSelector, prefersReduced) {
    var track = container.querySelector(trackSelector);
    var items = Array.prototype.slice.call(container.querySelectorAll(itemSelector));
    var segmentsWrap = container.querySelector('[data-listicle-segments]');
    if (!track || items.length === 0) return;

    var tilesPerPageAttr = parseInt(container.getAttribute('data-tiles-per-page'), 10);
    var autoSegments = !!(segmentsWrap && segmentsWrap.getAttribute('data-segment-mode') === 'auto');
    var visibleCount = 1;
    var pageCount = 1;
    var currentPage = 0;
    var ticking = false;
    var segmentPerItem = false;
    var lockIndex = null;
    var scrollEndTimer = null;
    var onScrollEnd = null;
    var settling = false;
    var scrollToken = 0;
    var autoplayMs = parseInt(container.getAttribute('data-autoplay-ms'), 10) || 0;
    var pauseHover = false;
    var pausePointer = false;
    var pauseHidden = typeof document.hidden === 'boolean' ? document.hidden : false;
    var pauseOffscreen = true;
    var fillPage = -1;

    function refreshPagingMetrics() {
      var maxScroll = maxScrollLeft(track);

      if (tilesPerPageAttr > 0 && !autoSegments) {
        visibleCount = tilesPerPageAttr;
      } else {
        visibleCount = measureVisibleCount(track, items);
      }

      // Overflowing track must stay paginated (4 cards / 3 visible → 2 dots)
      if (maxScroll > 8 && visibleCount >= items.length) {
        visibleCount = Math.max(1, items.length - 1);
      }

      // Auto: only show pagination when the track can actually scroll.
      // 2 cards that both fit (tablet ~50%) → pageCount 1 → bars hidden.
      // Delayed rebuilds handle first-paint maxScroll=0 before layout.
      if (maxScroll <= 8) {
        pageCount = 1;
      } else {
        pageCount = Math.max(2, Math.ceil(items.length / Math.max(1, visibleCount)));
      }

      segmentPerItem = visibleCount <= 1 && pageCount === items.length;
    }

    function rebuildSegments() {
      if (!segmentsWrap || !autoSegments) return;
      refreshPagingMetrics();

      if (pageCount <= 1) {
        segmentsWrap.hidden = true;
        return;
      }

      segmentsWrap.hidden = false;
      segmentsWrap.removeAttribute('hidden');
      var existing = segmentsWrap.querySelectorAll('[data-listicle-segment]');
      if (existing.length !== pageCount) {
        var label = segmentsWrap.getAttribute('aria-label') || 'Carousel';
        var html = '';
        for (var i = 0; i < pageCount; i++) {
          html +=
            '<button type="button" class="listicle-rail__segment' +
            (i === currentPage ? ' is-active' : '') +
            '" role="tab" aria-selected="' +
            (i === currentPage ? 'true' : 'false') +
            '" data-listicle-segment data-segment-index="' +
            i +
            '" aria-label="' +
            label +
            ' page ' +
            (i + 1) +
            '"><span class="listicle-rail__segment-fill" aria-hidden="true"></span></button>';
        }
        segmentsWrap.innerHTML = html;
      } else {
        existing.forEach(function (btn, i) {
          btn.setAttribute('data-segment-index', String(i));
        });
      }

      bindSegmentClicks();
      updateSegments();
      restartFillAnimation();
    }

    function targetScrollForPage(page) {
      var maxScroll = maxScrollLeft(track);
      if (page <= 0 || maxScroll <= 0) return 0;
      if (page >= pageCount - 1) return maxScroll;

      if (segmentPerItem) {
        return targetScrollForItem(track, items, page);
      }

      // Page N starts at item (N * visibleCount)
      var startIndex = page * visibleCount;
      if (!items[startIndex]) return maxScroll;
      return Math.min(slideOffsetInTrack(items[startIndex], track), maxScroll);
    }

    function nearestWindowPage() {
      var maxScroll = maxScrollLeft(track);
      if (pageCount <= 1 || maxScroll <= 0) return 0;

      var scrollLeft = track.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      for (var p = 0; p < pageCount; p++) {
        var dist = Math.abs(targetScrollForPage(p) - scrollLeft);
        if (dist < bestDist) {
          bestDist = dist;
          best = p;
        }
      }
      return best;
    }

    function updateSegments() {
      if (segmentsWrap) {
        var buttons = segmentsWrap.querySelectorAll('[data-listicle-segment]');
        var segmentTotal = buttons.length;
        if (segmentTotal > 0) {
          var activeIndex = lockIndex != null ? lockIndex : currentPage;
          if (activeIndex > segmentTotal - 1) activeIndex = segmentTotal - 1;
          if (activeIndex < 0) activeIndex = 0;
          buttons.forEach(function (btn, i) {
            var on = i === activeIndex;
            btn.classList.toggle('is-active', on);
            btn.classList.remove('is-complete');
            if (!on) {
              btn.classList.remove('is-filling');
              var fill = btn.querySelector('.listicle-rail__segment-fill');
              if (fill) {
                fill.style.animation = 'none';
                fill.style.transform = 'scaleX(0)';
              }
            }
            btn.setAttribute('aria-selected', on ? 'true' : 'false');
          });
        }
      }
    }

    function canAutoplay() {
      return autoplayMs > 0 && !prefersReduced && pageCount > 1;
    }

    function isAutoplayHeld() {
      return pauseHover || pausePointer || pauseHidden || pauseOffscreen;
    }

    function ensureSegmentFills() {
      if (!segmentsWrap) return;
      segmentsWrap.querySelectorAll('[data-listicle-segment]').forEach(function (btn) {
        if (!btn.querySelector('.listicle-rail__segment-fill')) {
          var fill = document.createElement('span');
          fill.className = 'listicle-rail__segment-fill';
          fill.setAttribute('aria-hidden', 'true');
          btn.appendChild(fill);
        }
      });
    }

    function syncAutoplayPausedAttr() {
      if (isAutoplayHeld()) {
        container.setAttribute('data-autoplay-paused', '');
      } else {
        container.removeAttribute('data-autoplay-paused');
      }
    }

    function restartFillAnimation() {
      if (!segmentsWrap) return;
      ensureSegmentFills();
      updateSegments();
      if (!canAutoplay() || pauseOffscreen) {
        fillPage = lockIndex != null ? lockIndex : currentPage;
        syncAutoplayPausedAttr();
        return;
      }
      var buttons = segmentsWrap.querySelectorAll('[data-listicle-segment]');
      var activeIndex = lockIndex != null ? lockIndex : currentPage;
      buttons.forEach(function (btn, i) {
        btn.classList.remove('is-filling', 'is-complete');
        var fill = btn.querySelector('.listicle-rail__segment-fill');
        if (fill) {
          fill.style.animation = 'none';
          fill.style.transform = i === activeIndex ? '' : 'scaleX(0)';
        }
      });
      var active = buttons[activeIndex];
      if (!active) {
        syncAutoplayPausedAttr();
        return;
      }
      var activeFill = active.querySelector('.listicle-rail__segment-fill');
      if (!activeFill) {
        syncAutoplayPausedAttr();
        return;
      }
      void activeFill.offsetWidth;
      activeFill.style.animation = '';
      active.classList.add('is-filling');
      fillPage = activeIndex;
      syncAutoplayPausedAttr();
    }

    function resumeAutoplayIfPossible() {
      syncAutoplayPausedAttr();
      if (isAutoplayHeld() || !canAutoplay()) return;
      var filling = segmentsWrap && segmentsWrap.querySelector('[data-listicle-segment].is-filling');
      var fillingIndex = filling ? parseInt(filling.getAttribute('data-segment-index'), 10) : -1;
      var activeIndex = lockIndex != null ? lockIndex : currentPage;
      if (filling && fillingIndex === activeIndex) return;
      restartFillAnimation();
    }

    function setCarouselInView(inView) {
      pauseOffscreen = !inView;
      if (!inView) {
        syncAutoplayPausedAttr();
        return;
      }
      restartFillAnimation();
    }

    function advanceAutoplay() {
      if (!canAutoplay() || isAutoplayHeld() || lockIndex != null || settling) return;
      var next = currentPage + 1;
      if (next >= pageCount) next = 0;
      scrollToPage(next);
    }

    function clearProgrammaticListeners() {
      if (scrollEndTimer) {
        window.clearTimeout(scrollEndTimer);
        scrollEndTimer = null;
      }
      if (onScrollEnd) {
        track.removeEventListener('scrollend', onScrollEnd);
        onScrollEnd = null;
      }
    }

    function restoreSnapAfter(targetLeft) {
      window.requestAnimationFrame(function () {
        track.scrollLeft = targetLeft;
        window.requestAnimationFrame(function () {
          track.style.removeProperty('scroll-snap-type');
          track.style.removeProperty('scroll-behavior');
          if (Math.abs(track.scrollLeft - targetLeft) > 3) {
            track.style.scrollSnapType = 'none';
            track.scrollLeft = targetLeft;
            window.requestAnimationFrame(function () {
              track.style.removeProperty('scroll-snap-type');
            });
          }
          settling = false;
        });
      });
    }

    function finishProgrammaticScroll(targetIndex, token) {
      if (token != null && token !== scrollToken) return;
      if (settling) return;
      settling = true;
      clearProgrammaticListeners();

      var targetLeft = targetScrollForPage(targetIndex);
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = targetLeft;

      currentPage = targetIndex;
      lockIndex = null;
      updateSegments();
      restoreSnapAfter(targetLeft);
      restartFillAnimation();
    }

    function programScrollTo(targetIndex) {
      clearProgrammaticListeners();
      settling = false;
      scrollToken += 1;
      var token = scrollToken;

      lockIndex = targetIndex;
      currentPage = targetIndex;
      updateSegments();
      restartFillAnimation();

      var targetLeft = targetScrollForPage(targetIndex);
      var goingBack = targetLeft < track.scrollLeft - 1;

      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = track.scrollLeft;

      window.requestAnimationFrame(function () {
        if (token !== scrollToken) return;

        targetLeft = targetScrollForPage(targetIndex);

        if (prefersReduced || goingBack || Math.abs(track.scrollLeft - targetLeft) < 1) {
          track.scrollLeft = targetLeft;
          finishProgrammaticScroll(targetIndex, token);
          return;
        }

        track.scrollTo({
          left: targetLeft,
          behavior: 'smooth'
        });

        onScrollEnd = function () {
          finishProgrammaticScroll(targetIndex, token);
        };
        track.addEventListener('scrollend', onScrollEnd);
        scrollEndTimer = window.setTimeout(onScrollEnd, 500);
      });
    }

    function scrollToPage(page) {
      var idx = Math.max(0, Math.min(page, pageCount - 1));
      programScrollTo(idx);
    }

    function syncFromScroll() {
      if (lockIndex != null || settling) return;
      if (segmentPerItem) {
        currentPage = nearestItemIndex(track, items);
      } else {
        currentPage = nearestWindowPage();
      }
      updateSegments();
    }

    function bindSegmentClicks() {
      if (!segmentsWrap) return;
      // Delegate once on the wrap so Liquid-rendered buttons also work
      if (segmentsWrap.getAttribute('data-listicle-seg-bound') === 'true') return;
      segmentsWrap.setAttribute('data-listicle-seg-bound', 'true');
      segmentsWrap.addEventListener('click', function (event) {
        var btn = event.target && event.target.closest
          ? event.target.closest('[data-listicle-segment]')
          : null;
        if (!btn || !segmentsWrap.contains(btn)) return;
        event.preventDefault();
        var segIndex = parseInt(btn.getAttribute('data-segment-index'), 10);
        if (isNaN(segIndex)) segIndex = 0;
        scrollToPage(segIndex);
      });
    }

    refreshPagingMetrics();
    if (autoSegments) {
      rebuildSegments();
      // Re-measure after layout so 3-up desktop settles to the right page count
      window.requestAnimationFrame(function () {
        rebuildSegments();
        window.setTimeout(rebuildSegments, 150);
      });
    } else if (segmentsWrap) {
      segmentPerItem =
        segmentsWrap.querySelectorAll('[data-listicle-segment]').length === items.length;
    }
    bindSegmentClicks();

    track.addEventListener(
      'scroll',
      function () {
        if (lockIndex != null || settling) return;
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          syncFromScroll();
          ticking = false;
        });
      },
      { passive: true }
    );

    var resizeTimer = null;
    function onResize() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        var prevPages = pageCount;
        refreshPagingMetrics();
        if (autoSegments && (pageCount !== prevPages || (pageCount > 1 && segmentsWrap.hidden))) {
          currentPage = Math.min(currentPage, Math.max(0, pageCount - 1));
          rebuildSegments();
        }
        syncFromScroll();
      }, 120);
    }

    window.addEventListener('resize', onResize);
    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(onResize);
      ro.observe(track);
    }

    if (segmentsWrap && segmentsWrap.getAttribute('data-listicle-fill-bound') !== 'true') {
      segmentsWrap.setAttribute('data-listicle-fill-bound', 'true');
      segmentsWrap.addEventListener('animationend', function (event) {
        var fill = event.target;
        if (!fill || !fill.classList || !fill.classList.contains('listicle-rail__segment-fill')) return;
        var btn = fill.closest('[data-listicle-segment]');
        if (!btn || !btn.classList.contains('is-filling')) return;
        var segIndex = parseInt(btn.getAttribute('data-segment-index'), 10);
        if (isNaN(segIndex) || segIndex !== currentPage) return;
        advanceAutoplay();
      });
    }

    function onPointerDown() {
      pausePointer = true;
      syncAutoplayPausedAttr();
    }

    function onPointerUp() {
      pausePointer = false;
      resumeAutoplayIfPossible();
    }

    container.addEventListener('pointerdown', onPointerDown);
    container.addEventListener('pointerup', onPointerUp);
    container.addEventListener('pointercancel', onPointerUp);
    container.addEventListener('mouseenter', function () {
      pauseHover = true;
      syncAutoplayPausedAttr();
    });
    container.addEventListener('mouseleave', function () {
      pauseHover = false;
      pausePointer = false;
      resumeAutoplayIfPossible();
    });
    container.addEventListener('focusin', function (event) {
      var target = event.target;
      if (target && target.closest && target.closest('[data-listicle-segment]')) return;
      pauseHover = true;
      syncAutoplayPausedAttr();
    });
    container.addEventListener('focusout', function (event) {
      var next = event.relatedTarget;
      if (next && container.contains(next)) return;
      pauseHover = false;
      resumeAutoplayIfPossible();
    });

    function onVisibility() {
      pauseHidden = document.hidden;
      if (pauseHidden) {
        syncAutoplayPausedAttr();
      } else {
        resumeAutoplayIfPossible();
      }
    }
    document.addEventListener('visibilitychange', onVisibility);

    var userScrollStopTimer = null;
    track.addEventListener(
      'scroll',
      function () {
        if (lockIndex != null || settling || !canAutoplay() || pauseOffscreen) return;
        window.clearTimeout(userScrollStopTimer);
        userScrollStopTimer = window.setTimeout(function () {
          if (lockIndex != null || settling || pauseOffscreen) return;
          if (currentPage === fillPage) return;
          restartFillAnimation();
        }, 180);
      },
      { passive: true }
    );

    ensureSegmentFills();
    window.requestAnimationFrame(function () {
      syncFromScroll();
      syncAutoplayPausedAttr();
    });

    if ('IntersectionObserver' in window) {
      var viewObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.target !== container) return;
            setCarouselInView(entry.isIntersecting);
          });
        },
        { threshold: 0.05, rootMargin: '40px 0px 40px 0px' }
      );
      viewObserver.observe(container);
    } else {
      setCarouselInView(true);
    }
  }

  function initListicleFeed(root) {
    if (!root || root.getAttribute('data-listicle-ready') === 'true') return;
    root.setAttribute('data-listicle-ready', 'true');

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    root.querySelectorAll('[data-listicle-video-rail]').forEach(function (rail) {
      bindSegmentCarousel(rail, '[data-listicle-video-track]', '[data-listicle-video-tile]', prefersReduced);
    });

    var autoplayRails = root.querySelectorAll('[data-listicle-video-rail][data-playback="autoplay"]');
    if (autoplayRails.length && 'IntersectionObserver' in window) {
      var videos = [];
      autoplayRails.forEach(function (railEl) {
        railEl.querySelectorAll('video').forEach(function (v) {
          v.muted = true;
          v.defaultMuted = true;
          v.playsInline = true;
          videos.push(v);
        });
      });
      if (videos.length) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!(entry.target instanceof HTMLVideoElement)) return;
              if (entry.target.getAttribute('data-user-paused') === 'true') return;
              if (entry.isIntersecting) {
                entry.target.muted = true;
                entry.target.play().catch(function () {});
              } else {
                entry.target.pause();
              }
            });
          },
          { threshold: 0.15 }
        );
        videos.forEach(function (v) {
          observer.observe(v);
        });
      }
    }

    root.querySelectorAll('[data-listicle-video-toggle]').forEach(function (btn) {
      if (btn.getAttribute('data-listicle-bound') === 'true') return;
      btn.setAttribute('data-listicle-bound', 'true');

      var frame = btn.closest('.listicle-rail__video-frame');
      if (!frame) return;
      var video = frame.querySelector('video');
      if (!video) return;
      var poster = frame.querySelector('.listicle-rail__video-poster');

      function flashControls() {
        frame.classList.add('is-controls-visible');
        if (frame._listicleControlsTimer) {
          window.clearTimeout(frame._listicleControlsTimer);
        }
        frame._listicleControlsTimer = window.setTimeout(function () {
          frame.classList.remove('is-controls-visible');
          frame._listicleControlsTimer = null;
        }, 700);
      }

      function setPlaying(playing) {
        frame.classList.toggle('is-playing', playing);
        btn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
        if (poster) {
          poster.hidden = playing;
        }
        if (!playing) {
          frame.classList.remove('is-controls-visible');
        }
      }

      function syncFromVideo() {
        setPlaying(!video.paused && !video.ended);
      }

      syncFromVideo();
      video.addEventListener('loadeddata', syncFromVideo);
      video.addEventListener('play', syncFromVideo);
      video.addEventListener('pause', syncFromVideo);

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (video.paused) {
          video.removeAttribute('data-user-paused');
          video.play().then(syncFromVideo).catch(function () {
            setPlaying(false);
          });
        } else {
          flashControls();
          video.setAttribute('data-user-paused', 'true');
          video.pause();
          syncFromVideo();
        }
      });
    });

    root.querySelectorAll('[data-listicle-card-carousel]').forEach(function (carousel) {
      bindSegmentCarousel(
        carousel,
        '[data-listicle-carousel-track]',
        '[data-listicle-carousel-slide]',
        prefersReduced
      );
    });

    root.querySelectorAll('[data-advertorial-read-more]').forEach(function (btn) {
      if (btn.getAttribute('data-listicle-bound') === 'true') return;
      btn.setAttribute('data-listicle-bound', 'true');
      btn.addEventListener('click', function () {
        var card = btn.closest('.advertorial-feed-review, .advertorial-story, .listicle-rail__ba-card');
        var quote = card && card.querySelector('[data-advertorial-quote]');
        if (!quote) return;
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        if (expanded) {
          quote.textContent = quote.getAttribute('data-quote-short') || quote.textContent;
          btn.setAttribute('aria-expanded', 'false');
          btn.textContent = 'Read more';
          card.classList.remove('is-expanded');
        } else {
          quote.textContent = quote.getAttribute('data-quote-full') || quote.textContent;
          btn.setAttribute('aria-expanded', 'true');
          btn.textContent = 'Read less';
          card.classList.add('is-expanded');
        }
      });
    });

    if (!prefersReduced && 'IntersectionObserver' in window) {
      var revealTargets = root.querySelectorAll('.listicle__reason, .listicle-rail__card');
      var revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('listicle--revealed');
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.01, rootMargin: '200px 0px 200px 0px' }
      );
      revealTargets.forEach(function (el) {
        revealObserver.observe(el);
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-listicle-feed]').forEach(initListicleFeed);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
